import { createContext } from 'react';

const MenuDialogContext = createContext();

const { Provider } = MenuDialogContext;
export { Provider as MenuDialogProvider };

export default MenuDialogContext;
